import API, { defaultHeaders } from '@/api';
import Storage from '@/service/Storage';

const course = (id) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/course/${id}`, { headers });
};

export default course;
